import React, { useEffect, useState } from "react";
import { useMoralis } from "react-moralis";
import MoralisDappContext from "./context";
import contractABIJson from "../../contracts/contractAbi.json";
import contractABIJsonLive from "../../contracts/contractAbiLive.json";
import ieduABIJson from "../../contracts/ieduABI.json";
import ieduABIJsonLive from "../../contracts/ieduABILive.json";
function MoralisDappProvider({ children }) {
  const { web3, Moralis, user } = useMoralis();
  const abiString = "";
  const [walletAddress, setWalletAddress] = useState();
  const [chainId, setChainId] = useState();

  // const [contractABI, setContractABI] = useState(
  //   '[ { "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "uint256", "name": "itemId", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "nftContract", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "indexed": false, "internalType": "address", "name": "seller", "type": "address" }, { "indexed": false, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "price", "type": "uint256" }, { "indexed": false, "internalType": "bool", "name": "sold", "type": "bool" } ], "name": "MarketItemCreated", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "uint256", "name": "itemId", "type": "uint256" }, { "indexed": false, "internalType": "address", "name": "owner", "type": "address" } ], "name": "MarketItemSold", "type": "event" }, { "inputs": [ { "internalType": "address", "name": "nftContract", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "uint256", "name": "price", "type": "uint256" } ], "name": "createMarketItem", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "nftContract", "type": "address" }, { "internalType": "uint256", "name": "itemId", "type": "uint256" } ], "name": "createMarketSale", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [], "name": "fetchMarketItems", "outputs": [ { "components": [ { "internalType": "uint256", "name": "itemId", "type": "uint256" }, { "internalType": "address", "name": "nftContract", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "address payable", "name": "seller", "type": "address" }, { "internalType": "address payable", "name": "owner", "type": "address" }, { "internalType": "uint256", "name": "price", "type": "uint256" }, { "internalType": "bool", "name": "sold", "type": "bool" } ], "internalType": "struct marketPlaceBoilerPlate.MarketItem[]", "name": "", "type": "tuple[]" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function"}]'
  // );
  const [contractABI, setContractABI] = useState(
    JSON.stringify(contractABIJson)
  );
  const [marketAddress, setMarketAddress] = useState(
    "0xDf2D12e5781e9c228CaBA6706f2FD9301fe48C78"
  );

  const [ieduABI, setIEDUABI] = useState(JSON.stringify(ieduABIJson));

  const [ieduAddress, setIEDUAddress] = useState(
    "0xbd5E96a0212f5831f35853765c73c2B84f8E9B70"
  );

  const[nftAddress, setNftAddress] = useState("");

  useEffect(() => {
    Moralis.onChainChanged(function (chain) {
      // console.log("changed", chain)
      setChainId(chain);
    });

    Moralis.onAccountsChanged(function (address) {
      setWalletAddress(address[0]);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // console.log("initial", web3.givenProvider?.chainId)
    switch (web3.givenProvider?.chainId){
      //testnet
      case "0x13881":
        setMarketAddress("0xDf2D12e5781e9c228CaBA6706f2FD9301fe48C78");
        setIEDUAddress("0xbd5E96a0212f5831f35853765c73c2B84f8E9B70");
        setIEDUABI(JSON.stringify(ieduABIJson));
        setContractABI(JSON.stringify(contractABIJson));
        setNftAddress("0x573Cb7d5064798B05A4dF809Bea630101A48eE5b");
        break;
      //mainnet
      case "0x89":
        setMarketAddress("0xF4F73b734DbE768740c967AB7B0A0CdFCf543AeF");
        setIEDUAddress("0xbAf8Ed1fc38af64575BEaC7213b9FE8B2b01d201");
        setIEDUABI(JSON.stringify(ieduABIJsonLive));
        setContractABI(JSON.stringify(contractABIJsonLive));
        setNftAddress("0x61102F24BAE44d2f8214B9197cfc8a7E992A18EB");
        break;
    }
    setChainId(web3.givenProvider?.chainId)
  });
  useEffect(
    () =>
      setWalletAddress(
        web3.givenProvider?.selectedAddress || user?.get("ethAddress")
      ),
    [web3, user]
  );

  return (
    <MoralisDappContext.Provider
      value={{
        walletAddress,
        chainId,
        marketAddress,
        setMarketAddress,
        contractABI,
        setContractABI,
        ieduABI,
        ieduAddress,
        nftAddress
      }}
    >
      {children}
    </MoralisDappContext.Provider>
  );
}

function useMoralisDapp() {
  const context = React.useContext(MoralisDappContext);
  if (context === undefined) {
    throw new Error("useMoralisDapp must be used within a MoralisDappProvider");
  }
  return context;
}

export { MoralisDappProvider, useMoralisDapp };
